if (!customElements.get('mana-product-visuals')) {
  customElements.define('mana-product-visuals', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.panels = Array.from(this.querySelectorAll('[data-mana-view]'));
      this.switcher = this.querySelector('.mana-visual-switch');
      this.preview = this.querySelector('[data-live-preview]');
      this.classList.add('mana-visual-enhanced');
      this.show('photos');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-mana-show]');
        if (button && this.contains(button)) this.show(button.dataset.manaShow);
      }, { signal });
      const enable = () => {
        if (!this.preview.querySelector('canvas')) return;
        this.switcher.hidden = false;
        this.previewReady = true;
        this.observer.disconnect();
      };
      this.observer = new MutationObserver(enable);
      this.observer.observe(this.preview, { childList: true, subtree: true });
      enable();
      const product = this.closest('product-info');
      const reveal = (event) => {
        if (this.previewReady && event.isTrusted && event.target.closest('[data-option]')) this.show('preview');
      };
      product?.addEventListener('input', reveal, { signal });
      product?.addEventListener('change', reveal, { signal });
    }
    show(view) {
      this.panels.forEach((panel) => {
        const inactive = panel.dataset.manaView !== view;
        panel.setAttribute('aria-hidden', String(inactive));
        panel.inert = inactive;
      });
      this.querySelectorAll('[data-mana-show]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.manaShow === view));
      });
      if (this.previewReady) window.dispatchEvent(new Event('resize'));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
